import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { ErrorBoundary } from './components/common/ErrorBoundary';
import { errorTracker } from './lib/error-tracking';
import { analyticsTracker } from './lib/analytics';
import './styles/globals.css';

errorTracker.init({
  endpoint: import.meta.env.VITE_ERROR_REPORT_ENDPOINT ?? '',
  release: `${import.meta.env.VITE_APP_VERSION}+${import.meta.env.VITE_APP_BUILD_ID}`,
  environment: import.meta.env.VITE_APP_ENV ?? 'development',
  enabled: !!import.meta.env.VITE_ERROR_REPORT_ENDPOINT,
  sampleRate: 1.0,
  maxBreadcrumbs: 20,
  flushBatchSize: 5,
  flushInterval: 3000,
});

analyticsTracker.init({
  endpoint: import.meta.env.VITE_ANALYTICS_ENDPOINT ?? '',
  release: `${import.meta.env.VITE_APP_VERSION}+${import.meta.env.VITE_APP_BUILD_ID}`,
  environment: import.meta.env.VITE_APP_ENV ?? 'development',
  enabled: !!import.meta.env.VITE_ANALYTICS_ENDPOINT,
  sampleRate: 1.0,
  flushBatchSize: 10,
  flushInterval: 5000,
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>
);
